function roundToCents(n) {
  return Math.round(n * 100) / 100;
}
export default roundToCents;
